// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Splitter Pane Component */
:host([container-queries]) {
  container-type: inline-size;
}

.ids-splitter-pane {
  overflow: auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* Padding */
:host([padding=xs]) .ids-splitter-pane {
  padding: var(--ids-space-08);
}

:host([padding=sm]) .ids-splitter-pane {
  padding: var(--ids-space-16);
}

:host([padding=md]) .ids-splitter-pane {
  padding: var(--ids-space-20);
}

:host([padding=lg]) .ids-splitter-pane {
  padding: var(--ids-space-24);
}

:host([padding=xl]) .ids-splitter-pane {
  padding: var(--ids-space-32);
}

/* Padding X */
:host([padding-x=xs]) .ids-splitter-pane {
  padding-inline: var(--ids-space-08);
}

:host([padding-x=sm]) .ids-splitter-pane {
  padding-inline: var(--ids-space-16);
}

:host([padding-x=md]) .ids-splitter-pane {
  padding-inline: var(--ids-space-20);
}

:host([padding-x=lg]) .ids-splitter-pane {
  padding-inline: var(--ids-space-24);
}

:host([padding-x=xl]) .ids-splitter-pane {
  padding-inline: var(--ids-space-32);
}

/* Padding Y */
:host([padding-y=xs]) .ids-splitter-pane {
  padding-block: var(--ids-space-08);
}

:host([padding-y=sm]) .ids-splitter-pane {
  padding-block: var(--ids-space-16);
}

:host([padding-y=md]) .ids-splitter-pane {
  padding-block: var(--ids-space-20);
}

:host([padding-y=lg]) .ids-splitter-pane {
  padding-block: var(--ids-space-24);
}

:host([padding-y=xl]) .ids-splitter-pane {
  padding-block: var(--ids-space-32);
}

/* Hide content when collapsed */
:host([collapsed]) .ids-splitter-pane {
  padding: 0;
  display: none;
  overflow: hidden;
}

/* Remove all padding when pane is very small */
@container (max-width: 80px) {
  :host([padding]) .ids-splitter-pane,
  :host([padding-x]) .ids-splitter-pane {
    padding-inline: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ids-splitter/ids-splitter-pane.scss"],"names":[],"mappings":"AAAA,gCAAA;AACA;EACE,2BAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA,YAAA;AACA;EACE,4BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA,cAAA;AACA;EACE,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA,cAAA;AACA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA,gCAAA;AACA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA,+CAAA;AACA;EACE;;IAEE,iBAAA;EACF;AACF","sourcesContent":["/* Ids Splitter Pane Component */\n:host([container-queries]) {\n  container-type: inline-size;\n}\n\n.ids-splitter-pane {\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* Padding */\n:host([padding='xs']) .ids-splitter-pane {\n  padding: var(--ids-space-08);\n}\n\n:host([padding='sm']) .ids-splitter-pane {\n  padding: var(--ids-space-16);\n}\n\n:host([padding='md']) .ids-splitter-pane {\n  padding: var(--ids-space-20);\n}\n\n:host([padding='lg']) .ids-splitter-pane {\n  padding: var(--ids-space-24);\n}\n\n:host([padding='xl']) .ids-splitter-pane {\n  padding: var(--ids-space-32);\n}\n\n/* Padding X */\n:host([padding-x='xs']) .ids-splitter-pane {\n  padding-inline: var(--ids-space-08);\n}\n\n:host([padding-x='sm']) .ids-splitter-pane {\n  padding-inline: var(--ids-space-16);\n}\n\n:host([padding-x='md']) .ids-splitter-pane {\n  padding-inline: var(--ids-space-20);\n}\n\n:host([padding-x='lg']) .ids-splitter-pane {\n  padding-inline: var(--ids-space-24);\n}\n\n:host([padding-x='xl']) .ids-splitter-pane {\n  padding-inline: var(--ids-space-32);\n}\n\n/* Padding Y */\n:host([padding-y='xs']) .ids-splitter-pane {\n  padding-block: var(--ids-space-08);\n}\n\n:host([padding-y='sm']) .ids-splitter-pane {\n  padding-block: var(--ids-space-16);\n}\n\n:host([padding-y='md']) .ids-splitter-pane {\n  padding-block: var(--ids-space-20);\n}\n\n:host([padding-y='lg']) .ids-splitter-pane {\n  padding-block: var(--ids-space-24);\n}\n\n:host([padding-y='xl']) .ids-splitter-pane {\n  padding-block: var(--ids-space-32);\n}\n\n/* Hide content when collapsed */\n:host([collapsed]) .ids-splitter-pane {\n  padding: 0;\n  display: none;\n  overflow: hidden;\n}\n\n/* Remove all padding when pane is very small */\n@container (max-width: 80px) {\n  :host([padding]) .ids-splitter-pane,\n  :host([padding-x]) .ids-splitter-pane {\n    padding-inline: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
